import {PlusOutlined} from '@ant-design/icons'
import {Avatar, Button} from 'antd'
import Translate from 'modules/local/Translate'
import React from 'react'
import {CustomPagingHeader, LayoutBuilder, NullAsDefault} from 'views/Shared'

const renderChannelAction = (
  onClick = NullAsDefault,
  mobileMode = ({ isSm }) => !!isSm
) => {
  return (
    <Translate>
      {(t) => (
        <LayoutBuilder
          value={mobileMode}
          params={{
            icon: <PlusOutlined />,
            style: { backgroundColor: '#ebf8ff', color: '#1253b2' },
          }}
          builder={({ params }) => (
            <div className="px-3">
              <Button
                block
                {...params}
                onClick={onClick}
                className="border-none rounded-full no-shadow">
                {t('create channel')}
              </Button>
            </div>
          )}
          orElse={({ params }) => (
            <CustomPagingHeader title="channels">
              <div
                className="cursor-pointer"
                onClick={onClick}>
                <Avatar
                  {...params}
                  shape="square"
                  className="bg-transparent rounded-lg cursor-pointer"
                />
              </div>
            </CustomPagingHeader>
          )}
        />
      )}
    </Translate>
  )
}

export default renderChannelAction
